module.exports = __webpack_public_path__ + "img/ico-live-now-sm.8ea5a605.png";